import { Switch, Route } from 'react-router-dom';
import { ROUTES } from 'Utils';
import ActivationCode from 'Pages/ActivationCode';
import ActivationSuccess from 'Pages/ActivationSuccess';
import ForgotPassword from 'Pages/ForgotPassword';
import Home from 'Pages/Home';
import LoggingIn from 'Pages/LoggingIn';
import Login from 'Pages/Login';
import LoginSuccess from 'Pages/LoginSuccess';
import Logout from 'Pages/Logout';
import NewPassword from 'Pages/NewPassword';
import Notification from 'Pages/Notification';
import Profile from 'Pages/profile/Index';
import Register from 'Pages/Register';
import ResendVerification from 'Pages/ResendVerification';
import ResetSuccess from 'Pages/ResetSuccess';
import SetInterests from 'Pages/SetInterests';
import SetPassword from 'Pages/SetPassword';
import Social from 'Pages/Social';
import SocialLogin from 'Pages/SocialLogin';
import Terms from 'Pages/Terms';
import UpdateRequired from 'Pages/UpdateRequired';
import Validate from 'Pages/Validate';
import Verification from 'Pages/Verification';
import VerificationSent from 'Pages/VerificationSent';
import WelcomeBack from 'Pages/WelcomeBack';
import DefaultLayout from 'Components/layouts/DefaultLayout';

const routeComponents = [
  {
    Component: ActivationCode,
    pathName: 'ACTIVATION_CODE',
  },
  {
    Component: ActivationSuccess,
    pathName: 'ACTIVATION_SUCCESS',
  },
  {
    Component: ForgotPassword,
    pathName: 'PAGE_FORGOT_PASSWORD',
  },
  {
    Component: Home,
    pathName: 'PAGE_HOME',
  },
  {
    Component: LoggingIn,
    pathName: 'PAGE_LOGGING_IN',
  },
  {
    Component: Login,
    pathName: 'PAGE_LOGIN',
  },
  {
    Component: LoginSuccess,
    pathName: 'PAGE_LOGIN_SUCCESS',
  },
  {
    Component: Logout,
    pathName: 'PAGE_LOGOUT',
  },
  {
    Component: NewPassword,
    pathName: 'PAGE_FORGOT_PASSWORD_CALLBACK',
  },
  {
    Component: Notification,
    pathName: 'PAGE_NOTIFICATION',
  },
  {
    Component: Profile,
    exact: false,
    layout: false,
    pathName: 'PAGE_PROFILE',
  },
  {
    Component: Register,
    pathName: 'PAGE_REGISTER',
  },
  {
    Component: ResendVerification,
    pathName: 'PAGE_RESEND_VERIFICATION',
  },
  {
    Component: ResetSuccess,
    pathName: 'PAGE_RESET_SUCCESS',
  },
  {
    Component: SetInterests,
    pathName: 'PAGE_SET_INTERESTS',
  },
  {
    Component: SetPassword,
    pathName: 'PAGE_SET_PASSWORD',
  },
  {
    Component: Social,
    pathName: 'PAGE_SOCIAL_TOKEN',
  },
  {
    Component: SocialLogin,
    pathName: 'PAGE_SOCIAL_LOGIN',
  },
  {
    Component: Terms,
    pathName: 'PAGE_TERMS',
  },
  {
    Component: UpdateRequired,
    pathName: 'PAGE_UPDATES_REQUIRED',
  },
  {
    Component: Validate,
    pathName: 'PAGE_VALIDATE',
  },
  {
    Component: Verification,
    pathName: 'PAGE_VERIFICATION',
  },
  {
    Component: VerificationSent,
    pathName: 'PAGE_VERIFICATION_SENT',
  },
  {
    Component: WelcomeBack,
    pathName: 'WELCOME_BACK',
  },
];

/**
 * Renders a page that matches URL.
 *
 * @return {*}
 * @constructor
 */
const Router = (props) => (
  <Switch>
    {routeComponents.map(
      ({ Component, exact = true, layout = true, pathName }, idx) => {
        const setRouteBody = () => {
          if (!layout) return <Component {...props} />;
          const Layout = Component?.Layout || DefaultLayout;
          return (
            <Layout {...props}>
              <Component {...props} />
            </Layout>
          );
        };

        return (
          <Route exact={exact} key={idx} path={ROUTES[pathName].url}>
            {setRouteBody()}
          </Route>
        );
      }
    )}
  </Switch>
);

export default Router;
